module.exports = "<div class=\"ot-attendants\">\n  <ot-avatar ng-repeat=\"item in vm.getAvatars()\" params=\"item\"></ot-avatar>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/directives/content/attendants.html
 ** module id = 258
 ** module chunks = 1
 **/